import { render, staticRenderFns } from "./SpaceSettingsTheme.vue?vue&type=template&id=8f7c5a7c&"
import script from "./SpaceSettingsTheme.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports